import { AuthRepository } from './authorization/AuthRepository';
import { RefreshAuthDelegate, PlanterHttpClient, CognitoHttpClient, } from '../services';
import { UserRepository } from './user/UserRepository';
import { CountriesRepository } from './countries/CountriesRepository';
import { CustomerRepository } from './customer/CustomerRepository';
import { CodeRepository } from './code/CodeRepository';
import { IngredientsRepository } from './ingredients/IngredientsRepository';
import { ActivityRepository } from './activity/ActivityRepository';
import { RecipeRepository } from './recipe/RecipeRepository';
import { FamilyRepository } from './family/FamilyRepository';
import { FavouriteRepository } from './favourite/FavouriteRepository';
import { PlanRepository } from './plan/PlanRepository';
import { FiltersRepository } from './filters/FiltersRepository';
import { CalorieRangeRepository } from './calorieRange/CalorieRangeRepository';
import { ShoppingListRepository } from './shoppingList/ShoppingListRespository';
import { NotificationsRepository } from './notifications/NotificationsRepository';
import { InAppPurchaseRepository } from './inAppPurchase/InAppPurchaseRepository';
import { RedeemCouponRepository } from './redeemCoupon/RedeemCouponRepository';
import { MealPrepRepository } from './mealPrep/MealPrepRepository';
export var createRepositories = function (_a) {
    var accessToken = _a.accessToken, refreshToken = _a.refreshToken, baseUrl = _a.baseUrl, errorHandler = _a.errorHandler, storage = _a.storage, cognitoRegion = _a.cognitoRegion, userPoolWebClientId = _a.userPoolWebClientId, locale = _a.locale, t = _a.t, onCountryDetected = _a.onCountryDetected, planterApiKey = _a.planterApiKey;
    var planterHttpClient = new PlanterHttpClient({
        baseUrl: baseUrl,
        errorHandler: errorHandler,
        accessToken: accessToken,
        refreshToken: refreshToken,
        locale: locale,
        t: t,
        onCountryDetected: onCountryDetected,
    });
    var cognitoHttpClient = new CognitoHttpClient({
        errorHandler: errorHandler,
        cognitoRegion: cognitoRegion,
        t: t,
    });
    var authRepo = new AuthRepository(cognitoHttpClient, storage, userPoolWebClientId);
    var refreshAuthDelegate = new RefreshAuthDelegate(authRepo);
    planterHttpClient.setupRefreshDelegate(refreshAuthDelegate);
    authRepo.addConsumer(planterHttpClient);
    var userRepo = new UserRepository(planterHttpClient);
    var countriesRepo = new CountriesRepository(planterHttpClient);
    var customerRepo = new CustomerRepository(planterHttpClient, planterApiKey);
    var codeRepo = new CodeRepository(planterHttpClient);
    var ingredientRepo = new IngredientsRepository(planterHttpClient);
    var activityRepo = new ActivityRepository(planterHttpClient);
    var recipeRepo = new RecipeRepository(planterHttpClient);
    var familyRepo = new FamilyRepository(planterHttpClient);
    var favouriteRepo = new FavouriteRepository(planterHttpClient);
    var planRepo = new PlanRepository(planterHttpClient);
    var filtersRepo = new FiltersRepository(planterHttpClient);
    var calorieRangeRepo = new CalorieRangeRepository(planterHttpClient);
    var shoppingListRepo = new ShoppingListRepository(planterHttpClient);
    var notificationsRepo = new NotificationsRepository(planterHttpClient);
    var inAppPurchaseRepo = new InAppPurchaseRepository(planterHttpClient);
    var redeemCouponRepo = new RedeemCouponRepository(planterHttpClient);
    var mealPrepRepo = new MealPrepRepository(planterHttpClient);
    return {
        authRepo: authRepo,
        userRepo: userRepo,
        countriesRepo: countriesRepo,
        customerRepo: customerRepo,
        codeRepo: codeRepo,
        ingredientRepo: ingredientRepo,
        activityRepo: activityRepo,
        recipeRepo: recipeRepo,
        familyRepo: familyRepo,
        favouriteRepo: favouriteRepo,
        planRepo: planRepo,
        filtersRepo: filtersRepo,
        calorieRangeRepo: calorieRangeRepo,
        shoppingListRepo: shoppingListRepo,
        notificationsRepo: notificationsRepo,
        inAppPurchaseRepo: inAppPurchaseRepo,
        redeemCouponRepo: redeemCouponRepo,
        mealPrepRepo: mealPrepRepo,
        planterHttpClient: planterHttpClient,
    };
};
